export default "__VITE_PUBLIC_ASSET__6a946852__"